import { render, staticRenderFns } from "./VacationRejectedWidget.vue?vue&type=template&id=0504730a&scoped=true&"
import script from "./VacationRejectedWidget.vue?vue&type=script&lang=js&"
export * from "./VacationRejectedWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0504730a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0504730a')) {
      api.createRecord('0504730a', component.options)
    } else {
      api.reload('0504730a', component.options)
    }
    module.hot.accept("./VacationRejectedWidget.vue?vue&type=template&id=0504730a&scoped=true&", function () {
      api.rerender('0504730a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employee/permission/vacations/widgets/VacationRejectedWidget.vue"
export default component.exports